import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Input, Button, Select } from 'antd';
import { Refresh, Search, ArrowDropDown } from '@material-ui/icons';

const { Option } = Select;

type SetupFilterType = {
  searchText: string;
  handleSearch: (e: any) => void;
  onAvailableFilter: (e: string) => void;
  onSort: (e: string) => void;
  onApplyFilter: () => void;
};

const SetupFilter: React.FC<SetupFilterType> = ({
  searchText,
  handleSearch,
  onAvailableFilter,
  onSort,
  onApplyFilter,
}) => {
  const [selectedFilterStatus, setSelectedFilterStatus] = useState<string>('');
  const [selectedSortedStatus, setSelectedSortedStatus] = useState<string>('');
  const intl = useIntl();
  const agentAvailable = [
    { value: '', label: intl.formatMessage({ id: 'All states' }) },
    { value: 'true', label: intl.formatMessage({ id: 'Published' }) },
    { value: 'false', label: intl.formatMessage({ id: 'Draft' }) },
  ];

  const agentSorts = [
    { value: 'Idesc', label: intl.formatMessage({ id: 'ID (desc)' }) },
    { value: 'Iasc', label: intl.formatMessage({ id: 'ID (asc)' }) },
    { value: 'Nasc', label: intl.formatMessage({ id: 'Name (A-Z)' }) },
    { value: 'Ndesc', label: intl.formatMessage({ id: 'Name (Z-A)' }) },
    { value: 'Sdesc', label: intl.formatMessage({ id: 'Published first' }) },
    { value: 'Sasc', label: intl.formatMessage({ id: 'Draft first' }) },
  ];

  const handleAvailableFilter = (value: string) => {
    setSelectedFilterStatus(value);
    onAvailableFilter(value);
  };

  const handleSort = (value: string) => {
    setSelectedSortedStatus(value);
    onSort(value);
  };

  const sortOptions = agentSorts.map(item => {
    let isDisabled = false;

    if (selectedFilterStatus === 'false' || selectedFilterStatus === 'true') {
      isDisabled = item.value !== 'Ndesc' && item.value !== 'Nasc' && item.value !== 'Idesc' && item.value !== 'Iasc';
    }

    return (
      <Option
        value={item.value}
        key={item.label}
        disabled={isDisabled}
        style={{ fontFamily: 'Lato', color: '#242c40' }}
      >
        {item.label}
      </Option>
    );
  });

  const filterOptions = agentAvailable.map(item => {
    let isDisabled = false;

    if (selectedSortedStatus === 'Sdesc' || selectedSortedStatus === 'Sasc') {
      isDisabled = item.value !== '';
    }

    return (
      <Option
        value={item.value}
        key={item.label}
        disabled={isDisabled}
        style={{ fontFamily: 'Lato', color: '#242c40' }}
      >
        {item.label}
      </Option>
    );
  });

  return (
    <div className="setup_filter_layout" id="setup_filter_layout">
      <Select
        className="availability_by"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Status' })}
        onChange={handleAvailableFilter}
        id="setup_status_filter"
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {filterOptions}
      </Select>
      <Select
        className="sort_by"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Sort by' })}
        onChange={handleSort}
        id="setup_name_filter"
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {sortOptions}
      </Select>
      <Button className="apply_filters_btn" onClick={onApplyFilter} id="setup_apply_filters_btn">
        <FormattedMessage id="Apply filters" />
        <Refresh />
      </Button>
      <Input
        suffix={<Search />}
        placeholder={intl.formatMessage({ id: 'Search setup' })}
        value={searchText}
        onChange={e => handleSearch(e)}
        onKeyDown={e => handleSearch(e)}
        id="setup_search_input"
        maxLength={200}
      />
    </div>
  );
};

export default SetupFilter;
